import constants from "../../constants";

export const CHECKOUT_STEP_CART = 1;
export const CHECKOUT_STEP_LOYALTY = 2;
export const CHECKOUT_STEP_PAYMENTSELECT = 3;
export const CHECKOUT_STEP_PAYMENT = 4;

export const CHECKOUT_PICK_UP_PAYMENT = 'DirectPay:DirectPayment';
export const CHECKOUT_B2B_PAYMENT = 'DirectPay:Invoice';

export const CHECKOUT_KLARNA_SHIPPING = 'KSS';
export const CHECKOUT_PICK_UP_SHIPPING = 'PickupAtLocation';
export const CHECKOUT_B2B_SHIPPING = 'B2BShipping';

export const CHECKOUT_KLARNA_PAYMENT_METHODS = {
  "NO": "KlarnaV3:Klarna KlarnaCheckout",
  "SE": "KlarnaV3:Klarna_SE KlarnaCheckout",
  "FI": "KlarnaV3:Klarna_FI KlarnaCheckout" // TODO: double check this when we integrate FI market
};

export const CHECKOUT_KLARNA_PAYMENT = CHECKOUT_KLARNA_PAYMENT_METHODS[window.__litium.constants.currentCountry];